var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDecorationStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    viewBox: "0 0 31 31",
    fill: "none",
    style: {
      minWidth: 30,
      minHeight: 30
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_28641)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_762_28641",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31,
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0336 0.0141602H0.0336304V30.0142H30.0336V0.0141602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_762_28641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0336 0.0141602C15.5429 8.0781 21.9696 14.5049 30.0336 15.0142C21.9696 15.5234 15.5429 21.9502 15.0336 30.0142C14.5244 21.9502 8.09757 15.5234 0.0336304 15.0142C8.09757 14.5049 14.5244 8.0781 15.0336 0.0141602Z",
    fill: "url(#paint0_linear_762_28641)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_762_28641",
    x1: 15.0336,
    y1: 0.0141602,
    x2: 15.0336,
    y2: 30.0142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4452A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66CCFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_28641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.0336304 0.0141602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDecorationStar);
export default __webpack_public_path__ + "static/media/icon-decoration-star.5dc3ab8d42ce61f587b3d5dccbc849bc.svg";
export { ForwardRef as ReactComponent };